import { math } from './utils';

class Section {
  constructor({
    scrollManager,
    section,
  } = {}) {

    this.scrollManager = scrollManager
    this.section = section;
    this.data = this.getData();

    this.checkViewPort();

    if (this.isVisible) {
      this.data.visibleOnLoad = true;
    }

    this.getData = this.getData.bind(this);

    window.addEventListener('resize', this.getData);

  }

  checkViewPort() {
    this.isVisible = this.data.top < this.scrollManager.viewport.height + this.scrollManager.data.current && this.data.bottom > this.scrollManager.data.current;
  }

  getData() {
    const bounds = this.section.getBoundingClientRect();

    return {
      current: 0,
      progress: 0,
      height: bounds.height,
      top: this.scrollManager.data.current + bounds.top,
      bottom: this.scrollManager.data.current + bounds.bottom,
      scrollTop: 0,
      visibleOnLoad: false,
      sectionId: this.section.dataset.scrollSection
    };
  }

  update(visibleOnLoad) {
    if (visibleOnLoad) {

      this.data.current = this.scrollManager.data.current;
      this.data.progress = math.normalize(this.data.current, this.data.bottom, 0);

    } else {

      this.data.current = (this.scrollManager.data.current - this.data.top) + this.scrollManager.viewport.height;
      this.data.progress = math.normalize(this.data.current, this.scrollManager.viewport.height + this.data.height, 0);
      this.data.progress = math.clamp(0.0, 1.0, this.data.progress)

    }
  }

  run() {
    this.update(this.data.visibleOnLoad);
  }
}

export default Section;
